/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2023-03-31 16:45:24
 * @LastEditTime: 2024-08-01 10:49:38
 */
import {
    Redirect,
    Route,
    BrowserRouter as Router,
    Switch,
} from "react-router-dom";
import Enter from "../activity/enter/enter";
import ActivityIntro from "../activity/intro/intro";
import Jury from "../activity/jury";
import Notice from "../activity/notice/notice";
import ActivityOrg from "../activity/organization/org";
import Require from '../activity/require/require';
import Home from "../home/home";
import Login from "../user/login/login";

const MainRouter = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/home" component={Home} />
        <Route exact path="/schedule" component={ActivityIntro} />
        <Route exact path="/org" component={ActivityOrg} />
        <Route exact path="/jury" component={Jury} />
        <Route exact path="/trends" component={Notice} />
        <Route path="/enter" component={Enter} />
        <Route exact path="/require" component={Require} />

        <Redirect to="/" />
      </Switch>
    </Router>
  );
};

export default MainRouter;
